import { UIText2 } from '@cian/ui-kit';
import { FC, PropsWithChildren } from 'react';
import styles from './AdvancedFilterRow.css';
import { NBSP } from 'shared/constants/symbols';

interface IAdvancedFilterRowProps {
  label: string;
  info?: React.ReactNode;
  isNew?: boolean;
}

export const AdvancedFilterRow: FC<PropsWithChildren<IAdvancedFilterRowProps>> = ({ label, info, isNew, children }) => {
  return (
    <div className={styles['row']}>
      <div className={styles['label']}>
        <UIText2 display="inline" fontWeight="bold">
          {isNew && <div className={styles['new-filter']} />}
          {label}
        </UIText2>

        {info && (
          <>
            {NBSP}
            {info}
          </>
        )}
      </div>
      <div>{children}</div>
    </div>
  );
};
